<template>
	<div class="sections">
		<section v-if="withExperience">
			<b-row align-v="center">
				<b-col md="4">{{ labels.experienceLabel }}</b-col>
				<b-col md="8" class="mt-2 mt-md-0">
					<Select
						v-model="experience"
						:options="experienceOptions"
						@input="experienceChanged"
					/>
				</b-col>
			</b-row>
		</section>
		<section v-if="withEducation">
			<b-row align-v="center">
				<b-col md="4">
					Hast du dazu eine Schule oder Ausbildung <span class="font-weight-extra-bold">abgeschlossen</span>?
				</b-col>
				<b-col md="8" class="mt-2 mt-md-0">
					<Dropdown
						v-model="educationsFinished"
						:characteristic-items="prepareCharacteristicItems(meta.schoolType)"
						multiple
						:nothing-allowed="{
							text: 'Nein'
						}"
						placeholder="- Mehrfachauswahl möglich -"
						:close-on-select="false"
						@input="emitChangeEvent"
					/>
				</b-col>
			</b-row>
		</section>
		<section v-if="withEducation">
			<b-row align-v="center">
				<b-col md="4">
					Hast du dazu eine <span class="font-weight-extra-bold">NICHT abgeschlossene</span>
					Schule / Ausbildung?
				</b-col>
				<b-col md="8" class="mt-2 mt-md-0">
					<Dropdown
						v-model="educationsUnfinished"
						:characteristic-items="prepareCharacteristicItems(meta.schoolType)"
						:nothing-allowed="{
							text: 'Nein'
						}"
						placeholder="- Mehrfachauswahl möglich -"
						multiple
						:close-on-select="false"
						@input="emitChangeEvent"
					/>
				</b-col>
			</b-row>
		</section>
		<section v-if="withSelfAssessment">
			<b-row align-v="center">
				<b-col md="4">{{ labels.selfAssessmentLabel }}</b-col>
				<b-col md="8" class="mt-2 mt-md-0">
					<Select
						v-model="selfAssessment"
						:options="selfAssessmentOptions"
						@input="selfAssessmentChanged"
					/>
				</b-col>
			</b-row>
		</section>
	</div>
</template>

<script>
import Dropdown from "@/vue/characteristic/Dropdown.vue";
import {ADDITIONS_INVISIBLE, hasTag} from "@/helper/characteristic/Tag";
import {mapState} from "vuex";
import {APPLICATION, get, JOB_PROFILE} from "@/helper/characteristic/Label";
import * as Event from "@/helper/tracking/Event";
import EventData from "@/helper/tracking/EventData";
import Select from "@/vue/common/form/Select.vue";
import _ from "lodash";

const LABELS_APPLICATION_DESIRE = {
	experienceLabel: 'Hast du darin Erfahrung im Beruf oder privat?',
	selfAssessmentLabel: 'Wie gut kannst du das?'
};

const LABELS_APPLICATION = {
	experienceLabel: 'Welche Erfahrung hast du darin im Beruf oder privat?',
	selfAssessmentLabel: 'Wie gut kannst du das?'
};

const LABELS_JOB_PROFILE = {
	experienceLabel: 'Welche Erfahrung muss man zumindest mitbringen?',
	selfAssessmentLabel: 'Wie gut muss man das schon beherrschen?'
};

export default {

	components: {
		Select,
		Dropdown,
	},

	props: {
		item: {
			type: Object,
			required: true,
		},
		experienceConfig: {
			type: Object,
			required: false,
		},
		selfAssessmentConfig: {
			type: Object,
			required: false,
		},
		educationConfig: {
			type: Object,
			required: false,
		},
		type: {
			type: String,
			required: false,
			default: 'application'
		},
		applicationDesire: {
			type: Boolean,
			required: false
		},
	},

	data ()
	{
		return {
			experience: this.item.experience,
			selfAssessment: this.item.selfAssessment,
			educationsFinished: this.item.educationsFinished,
			educationsUnfinished: this.item.educationsUnfinished,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		labelType ()
		{
			return this.type === 'application'
				? APPLICATION
				: JOB_PROFILE;
		},
		labels ()
		{
			return this.type === 'application'
				? (this.applicationDesire ? LABELS_APPLICATION_DESIRE : LABELS_APPLICATION)
				: LABELS_JOB_PROFILE;
		},
		withExperience ()
		{
			return this.experienceConfig?.enabled;
		},
		withSelfAssessment ()
		{
			return this.selfAssessmentConfig?.enabled;
		},
		withEducation ()
		{
			return this.educationConfig?.enabled;
		},
		experienceOptions ()
		{
			return this.getOptionsFromCharacteristicItems(this.meta.workExperience);
		},
		selfAssessmentOptions ()
		{
			return this.getOptionsFromCharacteristicItems(this.meta.skillSelfAssessment);
		}
	},

	methods: {
		getOptionsFromCharacteristicItems (items)
		{
			return _.map(this.prepareCharacteristicItems(items), characteristicItem =>
			{
				return {
					value: characteristicItem,
					text: get(characteristicItem, this.labelType)
				};
			});
		},
		experienceChanged (experience)
		{
			Event.push(
				new EventData()
					.setEvent(Event.CHARACTERISTIC_SELECTION)
					.setAction('Erfahrung')
					.setName(this.item.item.label + ': ' + experience.label)
			);

			this.emitChangeEvent();
		},
		selfAssessmentChanged (selfAssessment)
		{
			Event.push(
				new EventData()
					.setEvent(Event.CHARACTERISTIC_SELECTION)
					.setAction('Selbsteinschätzung')
					.setName(this.item.item.label + ': ' + selfAssessment.label)
			);

			this.emitChangeEvent();
		},
		prepareCharacteristicItems (characteristics)
		{
			return _.filter(
				characteristics,
				characteristic => !hasTag(characteristic, ADDITIONS_INVISIBLE)
			);
		},
		emitChangeEvent ()
		{
			this.$emit('change', {
				experience: this.withExperience
					? this.experience
					: undefined,
				selfAssessment: this.withSelfAssessment
					? this.selfAssessment
					: undefined,
				educationsFinished: this.withEducation
					? this.educationsFinished
					: undefined,
				educationsUnfinished: this.withEducation
					? this.educationsUnfinished
					: undefined,
			});
		}
	}
}
</script>
